const BASE_URL = process.env.VITE_APP_BASE_URL || '';
const REDIRECT_URI = process.env.VITE_APP_REDIRECT_URL || '';
const AZURE_APP_ID = process.env.VITE_APP_AZURE_ID || '';
const TENANT_ID = process.env.VITE_APP_TENANT_ID || '';
const AD_GROUP_PREFIX = process.env.VITE_APP_AD_GROUP_PREFIX || '';
const VITE_APP_TRACKER_URL = process.env.VITE_APP_TRACKER_URL || '';
const VITE_APP_TRACKER_API_KEY = process.env.VITE_APP_TRACKER_API_KEY || '';
export {
    AD_GROUP_PREFIX, AZURE_APP_ID, BASE_URL, REDIRECT_URI, TENANT_ID, VITE_APP_TRACKER_URL, VITE_APP_TRACKER_API_KEY
};
